export default __webpack_public_path__ + "2025 Seaweed-Based Bioplastics Data Mining Ingredient–Property Relations from the Scientific Literature.pdf";